module.exports = __webpack_public_path__ + "db7a2c8f05efd710073bab7bd3a8874d.jpg";